import { createFeatureSelector, createSelector } from '@ngrx/store';

import { notesFiltersAdapter, NotesFiltersState } from './notes-filters.reducers';

export const selectNotesFiltersState = createFeatureSelector<NotesFiltersState>('notesFilters');

export const {
  selectIds: selectNotesFiltersIds,
  selectEntities: selectNotesFiltersEntities,
  selectAll: selectAllNotesFilters,
  selectTotal: selectNotesFiltersTotal,
} = notesFiltersAdapter.getSelectors(selectNotesFiltersState);

export const selectActiveNotesFiltersId = createSelector(
  selectNotesFiltersState,
  (state) => state.activeNotesFiltersId
);

export const selectActiveNotesFilters = createSelector(
  selectAllNotesFilters,
  selectActiveNotesFiltersId,
  (notesFilters, activeNotesFiltersId) =>
    notesFilters.find(filters => filters.id === activeNotesFiltersId)
);
